import React from 'react'
import Header from "../Components/Header"
import TopHeader from '../Components/Header/topHeader'
import "../styles.css"

const Setting = () => {
  return (
    <>
      <div className='containers'>
        <Header />
        <div >
          <TopHeader title="Setting" />
          <div style={{padding:"30px 60px"}}>

          </div>
        </div>
      </div>
    </>
  )
}

export default Setting